import { render, staticRenderFns } from "./fhd.vue?vue&type=template&id=1c588b7a&scoped=true&"
import script from "./fhd.vue?vue&type=script&lang=js&"
export * from "./fhd.vue?vue&type=script&lang=js&"
import style0 from "./fhd.vue?vue&type=style&index=0&id=1c588b7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c588b7a",
  null
  
)

export default component.exports